import React from 'react';
import { Link } from 'react-router-dom';
import { User, Users,Sparkles,GamepadIcon} from 'lucide-react';




const Home = () => {





  return (
    <div className='w-full'>
      <section className="relative bg-gradient-to-b from-[#190003] to-red-500 text-white">
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="py-20 md:py-28">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="space-y-8">
                <div className="inline-flex items-center gap-2 bg-red-500/20 border border-red-200/20 rounded-full px-4 py-1.5">
                  <Sparkles className="w-4 h-4" />
                  <span className="text-sm font-medium">Welcome to Sprint 2025</span>
                </div>
                <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight">
                  Level Up Your <br />
                  Gaming Experience
                </h1>
                <p className="text-lg text-red-100 max-w-xl">
                  Join our community of gamers and experience the next level of gaming. 
                  Whether you're a solo player or love multiplayer action, we've got you covered.
                </p>
                <div className="flex flex-wrap gap-4">
                  <Link to="/browseGame" className="inline-flex items-center gap-2 bg-white text-red-600 px-6 py-3 rounded-lg font-semibold hover:bg-red-50 transition-colors">
                    <GamepadIcon className="w-5 h-5" />
                    View All Games
                  </Link>
                </div>
                <div className="flex items-center gap-8 pt-4">
                  <div>
                    <div className="text-3xl font-bold">15+</div>
                    <div className="text-red-200">Active Games</div>
                  </div>
                  <div>
                    <div className="text-3xl font-bold">1000+</div>
                    <div className="text-red-200">Players Available</div>
                  </div>
                </div>
              </div>
              <div className="relative lg:h-[600px] hidden lg:block">
                <div className="absolute inset-0 bg-gradient-to-br from-red-400 to-red-600 rounded-3xl transform rotate-6 blur-3xl opacity-30"></div>
                <img
                  src="/topgrowth.in.png"
                  width={600}
                  height={600}
                  alt="Gaming Experience"
                  className="relative rounded-3xl shadow-2xl"
                  priority
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <main className="flex-1 container mx-auto px-4 py-12">
    

  <h2 className="text-3xl font-bold text-center mb-12">Choose Your Path</h2>
  <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
    {/* Single Player Card */}
    <Link
      to="/singlePlayerGame"
      aria-label="Single Player Game"
      className="group h-full transition-all duration-300 hover:shadow-xl hover:-translate-y-1 bg-gradient-to-br from-red-500 to-red-600 text-white overflow-hidden rounded-lg"
    >
      <div className="p-6 sm:p-8">
        <div className="rounded-full bg-white/10 w-12 h-12 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
          <User className="w-6 h-6" />
        </div>
        <h3 className="text-2xl font-bold mb-3">Single Player</h3>
        <p className="text-red-50 leading-relaxed">
          Embark on a solo adventure through immersive worlds and challenging
          quests. Experience epic stories and master your skills in our
          carefully crafted single-player experiences.
        </p>
      </div>
    </Link>

    {/* Multiplayer Card */}
    <Link
      to="/multiPlayerGame"
      aria-label="Multiplayer Game"
      className="group h-full transition-all duration-300 hover:shadow-xl hover:-translate-y-1 bg-gradient-to-br from-red-600 to-red-700 text-white overflow-hidden rounded-lg"
    >
      <div className="p-6 sm:p-8">
        <div className="rounded-full bg-white/10 w-12 h-12 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
          <Users className="w-6 h-6" />
        </div>
        <h3 className="text-2xl font-bold mb-3">Team Player</h3>
        <p className="text-red-50 leading-relaxed">
          Team up or compete with friends in exciting multiplayer battles and
          adventures. Join our thriving community and experience gaming together
          in new and exciting ways.
        </p>
      </div>
    </Link>
  </div>
</main>

    </div>
  );
};

export default Home;